/** Colorblind-safe YES/NO mode preference (persisted). */
export const CB_STORAGE_KEY = "wen-cb-mode";

export function loadCbMode() {
  try {
    return localStorage.getItem(CB_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

export function saveCbMode(on) {
  try {
    localStorage.setItem(CB_STORAGE_KEY, on ? "1" : "0");
  } catch {
    /* ignore quota / private mode */
  }
}

/**
 * @param {Element} [root]
 * @param {boolean} [on]
 */
export function applyCbMode(root = document.documentElement, on = loadCbMode()) {
  root.classList.toggle("cb-mode", !!on);
}
